/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteDashboardSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteDashboardRequest = {
  /**
   * The dashboard to delete
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteDashboardSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteDashboardSecurity$outboundSchema: z.ZodMiniType<
  DeleteDashboardSecurity$Outbound,
  DeleteDashboardSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteDashboardSecurityToJSON(
  deleteDashboardSecurity: DeleteDashboardSecurity,
): string {
  return JSON.stringify(
    DeleteDashboardSecurity$outboundSchema.parse(deleteDashboardSecurity),
  );
}

/** @internal */
export type DeleteDashboardRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteDashboardRequest$outboundSchema: z.ZodMiniType<
  DeleteDashboardRequest$Outbound,
  DeleteDashboardRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteDashboardRequestToJSON(
  deleteDashboardRequest: DeleteDashboardRequest,
): string {
  return JSON.stringify(
    DeleteDashboardRequest$outboundSchema.parse(deleteDashboardRequest),
  );
}
